import EA from '../helpers/init';

export default EA.Methods.openEmbedVideo = ($this) => {
    const openVideo = $this.querySelector('.video-opener');
    const videoPlayer = $this.querySelector('.video-player');

    openVideo.addEventListener('click', (e) => {
        e.stopPropagation();
        videoPlayer.classList.toggle('active');
    });

    document.addEventListener('click' , () => {
        videoPlayer.classList.remove('active');
    });

    document.addEventListener('keyup', (e) => {
        if(e.key === 'Escape') {
            videoPlayer.classList.remove('active');
        }
    });
};
